import '../../scss/datepicker/index-bs4.scss';
import Datepicker from '../datepicker/Datepicker';
import cs from '../datepicker/i18n/locales/cs';

Object.assign(Datepicker.locales, cs);

export function initialize() {
    const elements = document.querySelectorAll('[data-datepicker]');

    elements.forEach(function(element) {
        new Datepicker(element, {
            language: element.dataset.datepicker
        });
    })
}

